import { defineComponent as _defineComponent } from 'vue'
import { toRefs, type DefineComponent } from 'vue';
import { type Props as IconProps } from '@/core/components/base/image/SvgThemedIcon.vue';

export interface Props {
    tag?: string | DefineComponent,
    theme?: 'light' | 'dark',
    title?: string,
    disabled?: boolean,
    hoverBackground?: string,
    active?: boolean,
    prefixIcon?: IconProps,
    suffixIcon?: IconProps,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    tag: { default: 'button' },
    theme: null,
    title: null,
    disabled: { type: Boolean },
    hoverBackground: { default: 'var(--neutral-surface-subtle)' },
    active: { type: Boolean },
    prefixIcon: null,
    suffixIcon: null
  },
  setup(__props: any) {

const props = __props as { tag: string | DefineComponent, theme?: 'light' | 'dark', title?: string, disabled?: boolean, hoverBackground: string, active?: boolean, prefixIcon?: IconProps, suffixIcon?: IconProps };

;



const {
    tag,
    theme,
    title,
    active,
    hoverBackground,
    disabled,
} = toRefs(props);

return { __sfc: true,props, tag, theme, title, active, hoverBackground, disabled }
}

})